module.exports = __webpack_public_path__ + "img/weight-scale.2491ca55.svg";